/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';

// Filter to add a new item in the Analytics dropdows.
addFilter( 'woocommerce_admin_products_report_filters', 'woocommerce-bookings/admin/analytics', (filterConfig, variationsConfig) => {
	let valueToPush = { };
	valueToPush["label"] = __( 'Bookable products', 'woocommerce-bookings' );
	valueToPush["value"] = 'bookings';

	filterConfig.forEach( function( obj ) {
		if ( obj.filters ) {
		  obj.filters.push( valueToPush );
		}
	} );

	return filterConfig;
}, 10 );
